__turbopack_context__.v({
  "articles": "a0YMDW_articles",
  "inverted": "a0YMDW_inverted",
  "navbarExpanded": "a0YMDW_navbarExpanded",
});
